import { useGetAllInterviewsQuery } from '@/app/features/recruitment/interview/interview.api';
import EmptyState from '@/components/EmptyState';
import { Calendar03Icon, Clock01Icon } from '@/icons';
import { Card, Flex, Skeleton, Space } from 'antd';
import dayjs from 'dayjs';
import { Link } from 'react-router';

// Fixed date range: tomorrow → 1 month from today — computed once at module level
const DATE_START = dayjs().add(1, 'day').format('YYYY-MM-DD');
const DATE_END = dayjs().add(1, 'month').format('YYYY-MM-DD');

export default function UpcomingInterviews() {
  const { data, isLoading, isFetching } = useGetAllInterviewsQuery({
    limit: 10,
    start_date: DATE_START,
    end_date: DATE_END,
  });

  const interviews = data?.data?.data ?? [];
  const loading = isLoading || isFetching;

  return (
    <div>
      <div className="text-white p-5 rounded-xl shadow-xl bg-theme-slate-800 border border-theme-gray-700 h-full">
        <div className="bg-theme-slate-800">
          <Flex align="center" justify="space-between" gap={16}>
            <div className="justify-start text-white text-2xl font-bold">
              Upcoming Interviews
            </div>

            <Link
              to={'/admin/recruitment/interviews'}
              className="text-theme-primary hover:!text-theme-primary text-base underline underline-offset-2 hover:underline"
            >
              See all
            </Link>
          </Flex>
        </div>

        <div className="overflow-y-auto h-[413px] mt-5 space-y-4">
          {loading ? (
            Array.from({ length: 5 }).map((_, i) => (
              <Card
                key={i}
                styles={{ body: { padding: '12px' } }}
                className="bg-theme-slate-900 border border-theme-gray-700"
              >
                <Skeleton active paragraph={{ rows: 3 }} />
              </Card>
            ))
          ) : interviews.length === 0 ? (
            <div className="flex h-full justify-center items-center">
              <EmptyState
                icon={<Calendar03Icon size={32} />}
                title="No Upcoming Interviews"
                description="There are no interviews scheduled for the next month."
              />
            </div>
          ) : (
            interviews.map((item) => (
              <Card
                key={item.id}
                styles={{ body: { padding: '12px' } }}
                className="bg-theme-slate-900 border border-theme-gray-700"
              >
                <Flex align="start" justify="space-between">
                  <div className="justify-start text-white text-2xl w-2/3">
                    {item.applicant_name || 'n/a'}
                  </div>
                  <div className="w-1/3">
                    <Space size={8} className="pt-1">
                      <Calendar03Icon
                        size={16}
                        className="text-theme-primary"
                      />
                      <div className="justify-start text-white text-sm font-bold">
                        {item.interview_date
                          ? dayjs(item.interview_date).format('YYYY/MM/DD')
                          : 'n/a'}
                      </div>
                    </Space>

                    <Space size={8}>
                      <Clock01Icon size={16} className="text-theme-primary" />
                      <div className="justify-start text-white text-sm font-bold">
                        {item.interview_time || 'n/a'}
                      </div>
                    </Space>
                  </div>
                </Flex>

                <div className="justify-start mt-3">
                  <span className="text-white text-base font-normal capitalize">
                    Interviewer :
                  </span>
                  <br />
                  <span className="text-white text-xl font-normal">
                    {item.evaluator_name || 'n/a'}
                  </span>
                </div>

                <Flex align="start" justify="space-between" className="mt-3">
                  <div className="justify-start w-2/3">
                    <span className="text-white text-base font-normal capitalize">
                      Job Applied :
                    </span>
                    <br />
                    <span className="text-white text-xl font-normal overflow-wrap break-words">
                      {item.job_title || 'n/a'}
                    </span>
                  </div>

                  <div className="justify-start w-1/3">
                    <span className="text-white text-base font-normal capitalize">
                      Type:
                    </span>
                    <br />
                    <span className="text-white text-xl font-normal overflow-wrap break-words">
                      {item.interview_type || 'n/a'}
                    </span>
                  </div>
                </Flex>
              </Card>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
